import { collection, query, getDocs, where } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../firebase.config";
import AI from "../domain/models/AI";
import { chunkArray } from "@leedpulse-monorepo/utils";

const FIRESTORE_IN_OPERATOR_LIMIT = 30;

/**
 * Fetches AIs in batch for a list of AI IDs
 * Respects the limit of 30 for Firestore's 'in' operator
 */
export async function getAIsBatch(aiIds: string[]): Promise<Map<string, AI>> {
  const aiMap = new Map<string, AI>();
  if (aiIds.length === 0) {
    return aiMap;
  }

  const db = firestore;
  const aiCollection = collection(db, FirestoreCollections.ai);

  // If we have more than 30 IDs, we need to split them into chunks
  if (aiIds.length > FIRESTORE_IN_OPERATOR_LIMIT) {
    const aiIdChunks = chunkArray(aiIds, FIRESTORE_IN_OPERATOR_LIMIT);
    
    for (const chunk of aiIdChunks) {
      const aiQuery = query(aiCollection, where('id', 'in', chunk));
      const aiSnapshot = await getDocs(aiQuery);
      
      aiSnapshot.docs.forEach((doc) => {
        const ai = AI.fromFirestore(doc);
        aiMap.set(ai.id, ai);
      });
    }
  } else {
    // If we have 30 or less, we can make a single query
    const aiQuery = query(aiCollection, where('id', 'in', aiIds));
    const aiSnapshot = await getDocs(aiQuery);
    
    aiSnapshot.docs.forEach((doc) => {
      const ai = AI.fromFirestore(doc);
      aiMap.set(ai.id, ai);
    });
  }

  return aiMap;
}
